import { store } from "./index";
import { set } from "./slices/homeSlice";
import services from "../Constant/service"; // Import your API service

export const loadTokenFromStorage = () => {
  const token = localStorage.getItem("ACCESS_TOKEN");
 
  
  if (token) {
    store.dispatch(set({ ACCESS_TOKEN: token })); // Restore Redux state
    services.setAuthorizationToken(token); // Set Axios headers
  }
};
